import PropTypes from "prop-types";
//Limitless imports
import { log as pilog } from "@limitless/common/utils";
import { useExpertMessageClassficationContext } from "../../../hooks/expert-message-classification/ExpertMessageClassificationContext";
import { validateMessageClassificationFormValidator } from "../../../utils/validators/MessageClassificationFormValidator";
const MessageClassificationForm = ({
  children
}) => {
  const {
    message,
    messageClassification,
    setMessageClassificationFieldValue,
    submitMessageClassification
  } = useExpertMessageClassficationContext();

  //add logic here

  const {
    conversationState,
    dialogues
  } = message;
  const isLastDialogueCustResolved = dialogues.length > 0 && dialogues[dialogues.length - 1].type === "custResolved";
  const log = pilog.getLogger("MessageClassificationForm");
  const {
    isFinishDisabled,
    isCancelDisabled,
    fieldErrors,
    isFormInvalid,
    isFormPristine,
    hasExpertTouchedMessage
  } = validateMessageClassificationFormValidator(messageClassification, message);
  const classificationEnabled = conversationState.showClassification;
  log.debug(fieldErrors);
  log.debug(messageClassification);
  return children({
    classificationFieldList: conversationState.editorState && conversationState.editorState.previewActions || [],
    fieldValues: messageClassification,
    fieldErrors,
    onFieldUpdate: setMessageClassificationFieldValue,
    onFormSubmit: !classificationEnabled && !isFormInvalid || isFormPristine ? null : submitMessageClassification,
    isFormInvalid,
    hasExpertTouchedMessage,
    isFinishDisabled: isFinishDisabled && !isLastDialogueCustResolved || message.loading || message.addingDialogue,
    isCancelDisabled
  });
};
export default MessageClassificationForm;
MessageClassificationForm.propTypes = {
  children: PropTypes.func.isRequired
};